import React, { useState } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import PreLoader from "./components/preloader/preloader";
import Navbar from "./components/navbar/navbar";
import Sidebar from "./components/sidebar/sidebar";
import Footer from "./components/footer/footer";
import Controlbar from "./components/controlbar/controlbar";

// Higher-order component to protect routes
const PrivateRoute = ({ component: Component, isAuthenticated, ...rest }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const loading = () => {
    setIsLoading(true);
  };

  const doneLoading = () => {
    setIsLoading(false);
  };

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <>
            <PreLoader key={location.pathname} />
            <Navbar />
            <Sidebar />
            <div className={isLoading ? "content-wrapper page-loading" : "content-wrapper"}>
              <Component onLoading={loading} onDoneLoading={doneLoading} {...props} />
            </div>
            <Footer />
            <Controlbar />
          </>
        ) : (
          <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
        )
      }
    />
  );
};

export default PrivateRoute;
